import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { currencyFormat, formatDate } from '../../utility/Helpers'

const WideCardBankTransferPayment = ({ data, onClose }) => {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)

  const handleCopy = (value) => {
    if (!value) return
    navigator.clipboard.writeText(value)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="container-fluid px-0">
      {/* Header */}
      <div
        className="px-4 py-4 text-white position-relative"
        style={{
          background: 'linear-gradient(135deg, #0062b0 0%, #004d8c 100%)',
          borderRadius: '20px 20px 0 0',
        }}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label={t('title.close')}
          className="d-flex align-items-center justify-content-center rounded-circle border-0 pointer"
          style={{
            position: 'absolute',
            top: 14,
            right: 14,
            width: 32,
            height: 32,
            backgroundColor: 'rgba(255,255,255,0.9)',
            color: '#004d8c',
            fontSize: 14,
          }}
        >
          <i className="fas fa-times"></i>
        </button>

        <div className="d-flex align-items-center mb-2 pr-5">
          <span
            className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 mr-3"
            style={{ width: 38, height: 38, backgroundColor: 'rgba(255,255,255,0.15)' }}
          >
            <i className="fas fa-university" style={{ fontSize: 16 }}></i>
          </span>
          <div>
            <h6 className="text-uppercase fw-semibold mb-0" style={{ letterSpacing: 0.5 }}>
              {t('title.bank_transfer_payment')}
            </h6>
            <small style={{ opacity: 0.85 }}>{data?.invoice_code || '-'}</small>
          </div>
        </div>
      </div>

      <div
        className="bg-white shadow-sm"
        style={{ borderRadius: '0 0 20px 20px', overflow: 'hidden' }}
      >
        {/* Total amount */}
        <div className="px-4 pt-4 pb-3 text-center border-bottom">
          <small className="text-secondary text-uppercase fw-semibold d-block mb-1">
            {t('title.bill.total_amount')}
          </small>
          <h3 className="fw-bold mb-2" style={{ color: '#004d8c' }}>
            {data?.total_amount || data?.withdrawal_amount
              ? currencyFormat(data.total_amount || data.withdrawal_amount, 'IDR')
              : '-'}
          </h3>
          {data?.due_date && (
            <span
              className="badge-pending d-inline-flex align-items-center px-3 py-1 rounded-pill font-size-12 fw-semibold"
              style={{ backgroundColor: '#FFF0B3', color: '#FA592B' }}
            >
              <i className="far fa-clock mr-2"></i>
              {t('title.bill.due_date')}: {formatDate(data.due_date, 'DD/MM/YYYY HH:mm')}
            </span>
          )}
        </div>

        {/* Bank card */}
        <div className="px-4 pt-4">
          <p className="text-uppercase fw-semibold text-secondary small mb-2">
            {t('title.bank_account_destination')}
          </p>

          <div
            className="rounded-4 p-4 position-relative text-white"
            style={{
              background: 'linear-gradient(135deg, #1a2b4a 0%, #0d1826 100%)',
              minHeight: 140,
            }}
          >
            <div className="d-flex justify-content-between align-items-start mb-4">
              <span className="fw-semibold text-uppercase" style={{ letterSpacing: 1 }}>
                {data?.withdrawal_bank_code || '-'}
              </span>
              <i className="fas fa-university" style={{ fontSize: 20, opacity: 0.6 }}></i>
            </div>

            <div className="mb-3">
              <small className="d-block mb-1" style={{ opacity: 0.65, fontSize: 10 }}>
                {t('title.bank_account_number')}
              </small>
              <div className="d-flex align-items-center">
                <span
                  className="fw-bold"
                  style={{ fontSize: 22, letterSpacing: 2, fontFamily: 'monospace' }}
                >
                  {data?.withdrawal_bank_account_number || '-'}
                </span>
                {data?.withdrawal_bank_account_number && (
                  <button
                    type="button"
                    onClick={() => handleCopy(data.withdrawal_bank_account_number)}
                    className="btn btn-sm ml-3 border-0"
                    style={{
                      backgroundColor: copied ? 'rgba(32,207,60,0.2)' : 'rgba(255,255,255,0.12)',
                      color: copied ? '#20CF3C' : '#fff',
                      transition: 'all .2s',
                    }}
                  >
                    <i className={`fas ${copied ? 'fa-check' : 'fa-copy'} mr-1`}></i>
                    {copied ? t('title.copied') : t('button.copy')}
                  </button>
                )}
              </div>
            </div>

            <div>
              <small className="d-block mb-1" style={{ opacity: 0.65, fontSize: 10 }}>
                {t('title.bank_account_holder')}
              </small>
              <span className="fw-semibold">
                {data?.withdrawal_bank_account_holder_name || '-'}
              </span>
            </div>
          </div>
        </div>

        {/* Instructions */}
        <div className="px-4 py-4">
          <p className="text-uppercase fw-semibold text-secondary small mb-2">
            {t('title.payment_instruction')}
          </p>
          <ol className="pl-3 mb-0" style={{ color: '#495057' }}>
            <li className="mb-1 font-size-13">{t('message.bank_transfer_step_1')}</li>
            <li className="mb-1 font-size-13">{t('message.bank_transfer_step_2')}</li>
            <li className="font-size-13">{t('message.bank_transfer_step_3')}</li>
          </ol>
        </div>
      </div>
    </div>
  )
}

WideCardBankTransferPayment.propTypes = {
  data: PropTypes.object,
  onClose: PropTypes.func,
}

export default WideCardBankTransferPayment
